<script>
import Dropdown from 'primevue/dropdown';
export default {
  extends: Dropdown,
  methods: {
    removerAcentos(texto) {
      if (texto && texto.search(/[\xC0-\xFF]/g) > -1) {
          return texto
          .replace(/[\xC0-\xC5]/g, "A")
          .replace(/[\xC6]/g, "AE")
          .replace(/[\xC7]/g, "C")
          .replace(/[\xC8-\xCB]/g, "E")
          .replace(/[\xCC-\xCF]/g, "I")
          .replace(/[\xD0]/g, "D")
          .replace(/[\xD1]/g, "N")
          .replace(/[\xD2-\xD6\xD8]/g, "O")
          .replace(/[\xD9-\xDC]/g, "U")
          .replace(/[\xDD]/g, "Y")
          .replace(/[\xDE]/g, "P")
          .replace(/[\xE0-\xE5]/g, "a")
          .replace(/[\xE6]/g, "ae")
          .replace(/[\xE7]/g, "c")
          .replace(/[\xE8-\xEB]/g, "e")
          .replace(/[\xEC-\xEF]/g, "i")
          .replace(/[\xF1]/g, "n")
          .replace(/[\xF2-\xF6\xF8]/g, "o")
          .replace(/[\xF9-\xFC]/g, "u")
          .replace(/[\xFE]/g, "p")
          .replace(/[\xFD\xFF]/g, "y")
      }
      return texto;
    }
  },
  computed: {
    visibleOptions() {
      if (this.filterValue && this.filterValue.trim().length > 0) {
      // Ajuste no filtro, adicionado -> this.removerAcentos
      return this.options.filter(option => this.removerAcentos(this.getOptionLabel(option).toLocaleLowerCase(this.filterLocale))
      .indexOf(this.removerAcentos(this.filterValue)
      .toLocaleLowerCase(this.filterLocale)) > -1);
      } else
          return this.options;
    },
  }
}
</script>
<style>
</style>